'use client';
import * as React from 'react';
import React__default from 'react';
import { Link as Link$1 } from 'react-router-dom';
import { ThemeContext } from '../Theme/index.js';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */


var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

function Base(props) {
    var _a = props.appendClassNames, appendClassNames = _a === void 0 ? "" : _a;
    return (React.createElement(React.Fragment, null,
        React.createElement("footer", { className: appendClassNames }, props.children)));
}

var Link = React.forwardRef(function (props, ref) {
    var _a = props.hideCrawl, hideCrawl = _a === void 0 ? false : _a;
    var isReactSnap = navigator && navigator.userAgent === "ReactSnap";
    props["hideCrawl"]; var linkProps = __rest(props, ['hideCrawl']);
    var linkComponent = React.createElement(Link$1, __assign({}, linkProps, { ref: ref }), props.children);
    if (!hideCrawl) {
        return linkComponent;
    }
    return React.createElement(React.Fragment, null, !isReactSnap && linkComponent);
});

function AlliedContainer(props) {
    var _a = props.description, description = _a === void 0 ? "Singapore’s Top Container Depot" : _a, _b = props.menuItems, menuItems = _b === void 0 ? [] : _b, _c = props.mediaItems, mediaItems = _c === void 0 ? [] : _c, _d = props.certificateItems, certificateItems = _d === void 0 ? [] : _d;
    var currentTs = new Date();
    return (React.createElement(Base, null,
        React.createElement("div", { className: "flex flex-wrap justify-center px-4 md:px-6 py-4 md:py-7 bg-acem-black" },
            React.createElement("div", { className: "flex justify-between flex-wrap w-full py-4" },
                React.createElement("div", { className: "w-full lg:w-2/3 py-4" },
                    props.logoUrl ?
                        React.createElement(Link, { to: props.logoUrl },
                            React.createElement("img", { src: props.logoImage, alt: "logo", className: "w-52 h-20" }))
                        :
                            React.createElement("img", { src: props.logoImage, alt: "logo", className: "w-52 h-20" }),
                    React.createElement("p", { className: "w-full my-2 text-acem-white" }, description),
                    certificateItems.length > 0 &&
                        React.createElement("ul", { className: "mt-10 flex flex-row gap-2 md:!gap-4" }, certificateItems.map(function (certificateItem, i) {
                            return (React.createElement("li", { key: "certificate-item-".concat(i) }, certificateItem.content));
                        })),
                    props.certificateDescription &&
                        React.createElement("p", { className: "w-full my-2 text-acem-white" }, props.certificateDescription)),
                React.createElement("div", { className: "grid grid-cols-2 md:!grid-cols-3 gap-2 md:!gap-8 w-full lg:!w-1/3" }, menuItems.map(function (menuItem, i) {
                    return (React.createElement("div", { key: "footer-menu-".concat(i) },
                        React.createElement("p", { className: "block text-acem-white font-bold" }, menuItem.heading),
                        React.createElement("ul", null, menuItem.items.map(function (listItem, j) {
                            return (React.createElement("li", { key: "footer-item-".concat(j) },
                                React.createElement(Link, { to: listItem.to, target: listItem.target, hideCrawl: listItem.hideCrawl, className: "block no-underline text-acem-white my-4 md:my-7" }, listItem.content)));
                        }))));
                }))),
            React.createElement("hr", { className: "h-1 w-full my-4 border-acem-white" }),
            React.createElement("div", { className: "grid grid-cols-1 md:grid-cols-2 w-full" },
                React.createElement("div", { className: "text-acem-white my-2" },
                    "Copyright \u00A9 2017 - ",
                    currentTs.getFullYear(),
                    " | Allied Container Group"),
                React.createElement("div", { className: "flex justify-start md:justify-end items-center gap-4 md:gap-6 my-2" }, mediaItems.map(function (mediaItem, i) {
                    return (React.createElement(Link, { key: "footer-social-item-".concat(i), to: mediaItem.to, hideCrawl: mediaItem.hideCrawl, target: "_blank" }, mediaItem.content));
                }))))));
}

var ContainerSize;
(function (ContainerSize) {
    ContainerSize["FULL"] = "full";
    ContainerSize["XXXLARGE"] = "3xl";
    ContainerSize["XXLARGE"] = "2xl";
    ContainerSize["XLARGE"] = "xl";
    ContainerSize["LARGE"] = "lg";
    ContainerSize["MEDIUM"] = "md";
    ContainerSize["SMALL"] = "sm";
})(ContainerSize || (ContainerSize = {}));
var defaultTheme = new Map();
defaultTheme.set("size-".concat(ContainerSize.FULL), "w-full px-3 mx-auto");
defaultTheme.set("size-".concat(ContainerSize.XXXLARGE), "w-full px-3 mx-auto bs-3xl:max-w-bs-3xl");
defaultTheme.set("size-".concat(ContainerSize.XXLARGE), "w-full px-3 mx-auto bs-2xl:max-w-bs-2xl bs-3xl:max-w-bs-3xl");
defaultTheme.set("size-".concat(ContainerSize.XLARGE), "w-full px-3 mx-auto bs-xl:max-w-bs-xl bs-2xl:max-w-bs-2xl bs-3xl:max-w-bs-3xl");
defaultTheme.set("size-".concat(ContainerSize.LARGE), "w-full px-3 mx-auto bs-lg:max-w-bs-lg bs-xl:max-w-bs-xl bs-2xl:max-w-bs-2xl bs-3xl:max-w-bs-3xl");
defaultTheme.set("size-".concat(ContainerSize.MEDIUM), "w-full px-3 mx-auto bs-md:max-w-bs-md bs-lg:max-w-bs-lg bs-xl:max-w-bs-xl bs-2xl:max-w-bs-2xl bs-3xl:max-w-bs-3xl");
defaultTheme.set("size-".concat(ContainerSize.SMALL), "w-full px-3 mx-auto bs-sm:max-w-bs-sm bs-md:max-w-bs-md bs-lg:max-w-bs-lg bs-xl:max-w-bs-xl bs-2xl:max-w-bs-2xl bs-3xl:max-w-bs-3xl");
var ContainerStyle = /** @class */ (function () {
    function ContainerStyle() {
        this.size = "";
        this.appendedClassNames = "";
    }
    ContainerStyle.prototype.build = function () {
        var style = "";
        if (defaultTheme.has("size-".concat(this.size))) {
            style += defaultTheme.get("size-".concat(this.size));
        }
        if (this.appendedClassNames !== "") {
            style += " " + this.appendedClassNames;
        }
        return style;
    };
    ContainerStyle.prototype.setSize = function (size) {
        this.size = size;
        return this;
    };
    ContainerStyle.prototype.appendClassNames = function (classNames) {
        this.appendedClassNames = classNames || "";
        return this;
    };
    return ContainerStyle;
}());

var styleBuilder$1 = new ContainerStyle();
function Container(props) {
    var _a = props.size, size = _a === void 0 ? ContainerSize.MEDIUM : _a;
    var handleClick = function () {
        props.onClick && props.onClick();
    };
    var styleClassNames = styleBuilder$1.
        setSize(size).
        appendClassNames(props.appendClassNames).
        build();
    return (React.createElement("div", { onClick: handleClick, className: styleClassNames, style: props.style }, props.children));
}

function AlliedContainer2(props) {
    var _a = props.description, description = _a === void 0 ? "Your Trusted Partner in Efficient Middle Mile Logistics" : _a, _b = props.menuItems, menuItems = _b === void 0 ? [] : _b, _c = props.mediaItems, mediaItems = _c === void 0 ? [] : _c, _d = props.contactItems, contactItems = _d === void 0 ? [] : _d, _e = props.certificateItems, certificateItems = _e === void 0 ? [] : _e;
    return (React.createElement(Base, { appendClassNames: "font-satoshi bg-acem2-cloud" },
        React.createElement(Container, { size: "full" },
            React.createElement("div", { className: "grid grid-cols-12 gap-8 md:px-4 py-4" },
                React.createElement("div", { className: "col-span-12 lg:col-span-4 3xl:col-span-3" },
                    React.createElement("div", { className: "flex flex-col gap-4" },
                        description &&
                            React.createElement("p", { className: "font-manrope font-medium text-sm" }, description),
                        React.createElement("div", { className: "flex flex-col gap-2" },
                            React.createElement("p", { className: "font-medium text-3xl text-acem2-primary" }, "Allied Containers"),
                            React.createElement("hr", { className: "w-1/5 h-1 border-acem2-primary" })),
                        mediaItems.length > 0 &&
                            React.createElement("div", { className: "flex flex-row gap-6 justify-start items-center" }, mediaItems.map(function (mediaItem, i) {
                                return (React.createElement(React.Fragment, { key: "media-item-".concat(i) },
                                    React.createElement(Link, { to: mediaItem.to, target: mediaItem.target, hideCrawl: mediaItem.hideCrawl }, mediaItem.content)));
                            })),
                        contactItems.length > 0 &&
                            React.createElement("div", { className: "flex flex-col gap-4 justify-start items-start" }, contactItems.map(function (contactItem, i) {
                                return (React.createElement(React.Fragment, { key: "contact-item-".concat(i) },
                                    React.createElement(Link, { to: contactItem.to, target: contactItem.target, hideCrawl: contactItem.hideCrawl }, contactItem.content)));
                            })))),
                React.createElement("div", { className: "col-span-12 lg:col-span-8 3xl:col-span-9 lg:p-4" },
                    React.createElement("div", { className: "grid grid-cols-2 lg:!grid-cols-4 gap-x-2 gap-y-12 md:!gap-6" }, menuItems.map(function (menuItem, i) {
                        return (React.createElement("div", { key: "footer-menu-".concat(i), className: "flex flex-col gap-6 md:!gap-10" },
                            React.createElement("p", { className: "block font-medium text-acem2-black text-2xl" }, menuItem.heading),
                            menuItem.items.length > 0 &&
                                React.createElement("ul", { className: "flex flex-col justify-center items-start gap-4 md:gap-8" }, menuItem.items.map(function (listItem, j) {
                                    return (React.createElement("li", { key: "footer-item-".concat(j) },
                                        React.createElement(Link, { to: listItem.to, target: listItem.target, hideCrawl: listItem.hideCrawl, className: "block no-underline text-acem2-black hover:text-acem2-maroon" }, listItem.content)));
                                }))));
                    })),
                    React.createElement("div", { className: "flex justify-end items-center mt-6" },
                        React.createElement("div", { className: "flex flex-col gap-2" },
                            certificateItems.length > 0 &&
                                React.createElement("ul", { className: "flex flex-row gap-2 md:gap-4" }, certificateItems.map(function (certificateItem, i) {
                                    return (React.createElement("li", { key: "certificate-item-".concat(i) }, certificateItem.content));
                                })),
                            props.certificateDescription &&
                                React.createElement("p", { className: "w-full text-black" }, props.certificateDescription))))))));
}

var linkStyle = "font-normal font-segoe text-base text-black hover:!text-white no-underline ease-out duration-200 mr-4 md:mr-6";
function AlliedFood(props) {
    var _a = props.navigationItems, navigationItems = _a === void 0 ? [] : _a, _b = props.menuItems, menuItems = _b === void 0 ? [] : _b, _c = props.mediaItems, mediaItems = _c === void 0 ? [] : _c;
    return (React.createElement(Base, null,
        React.createElement("div", { className: "bg-afood-secondary px-4 md:px-6 lg:px-24 py-4 md:py-2" },
            React.createElement("div", { className: "px-3 mx-auto w-full max-w-screen-xl" },
                React.createElement("div", { className: "flex flex-col lg:flex-row lg:justify-between lg:items-center py-4 border-b-1 border-afood-primary" },
                    React.createElement("ul", { className: "flex flex-col lg:flex-row flex-wrap lg:items-center gap-6 px-0 my-0 font-medium text-sm text-gray-500" },
                        React.createElement("li", { className: "flex justify-between items-center" },
                            props.logoUrl ?
                                React.createElement(Link, { to: props.logoUrl, className: "mr-4 md:mr-6" },
                                    React.createElement("img", { alt: "logo", src: props.logoImage, className: "w-24 h-9" }))
                                :
                                    React.createElement("div", { className: "mr-4 md:mr-6" },
                                        React.createElement("img", { alt: "logo", src: props.logoImage, className: "w-24 h-9" })),
                            React.createElement("div", { className: "flex text-sm text-gray-500 text-center visible lg:hidden" }, mediaItems.map(function (mediaItem, i) {
                                return (React.createElement(Link, { key: "footer-media-mobile-".concat(i), target: mediaItem.target || "_new", to: mediaItem.to, hideCrawl: mediaItem.hideCrawl, className: "hover:underline mr-4 md:mr-6" }, mediaItem.content));
                            }))),
                        navigationItems.map(function (navItem, i) {
                            return (React.createElement("li", { key: "footer-nav-item-".concat(i) },
                                React.createElement(Link, { to: navItem.to, target: navItem.target, hideCrawl: navItem.hideCrawl, className: linkStyle }, navItem.content)));
                        })),
                    React.createElement("div", { className: "flex text-sm text-gray-500 sm:text-center xs:invisible sm:invisible lg:visible" }, mediaItems.map(function (mediaItem, i) {
                        return (React.createElement(Link, { key: "footer-media-desktop-".concat(i), target: mediaItem.target || "_new", to: mediaItem.to, hideCrawl: mediaItem.hideCrawl, className: "hover:underline mr-4 md:mr-6" }, mediaItem.content));
                    })))),
            React.createElement("div", { className: "mx-auto w-full max-w-screen-xl" },
                React.createElement("div", { className: "grid grid-cols-12 gap-4 md:gap-6 px-3 py-4 lg:py-6" }, menuItems.map(function (menu, i) {
                    return (React.createElement("div", { key: "footer-main-item-".concat(i), className: "col-span-12 sm:col-span-6 md:col-span-3 lg:col-span-3 border-b-1 border-afood-primary sm:border-0" },
                        React.createElement("ul", { className: "pl-0 text-gray-500 font-medium" }, menu.items.map(function (menuItem, j) {
                            return (React.createElement("li", { key: "footer-menu-item-".concat(i, "-").concat(j), className: "mb-4" },
                                React.createElement(Link, { to: menuItem.to, target: menuItem.target, hideCrawl: menuItem.hideCrawl, className: linkStyle }, menuItem.content)));
                        }))));
                }))))));
}

function Winspec(props) {
    var _a = props.name, name = _a === void 0 ? "Winspec Group" : _a, _b = props.description, description = _b === void 0 ? "Sister Company of Allied" : _b, _c = props.menuItems, menuItems = _c === void 0 ? [] : _c, _d = props.mediaItems, mediaItems = _d === void 0 ? [] : _d;
    var currentTs = new Date();
    return (React.createElement(Base, null,
        React.createElement("div", { className: "bg-winspec-primary px-4 sm:px-20 md:px-6 lg:px-24 3xl:px-64 py-4 md:py-7" },
            React.createElement("div", { className: "flex flex-wrap justify-center" },
                React.createElement("div", { className: "flex flex-col lg:flex-row justify-between items-start gap-6 w-full py-4" },
                    React.createElement("div", { className: "w-full lg:w-1/3 flex flex-col justify-start items-start gap-6" },
                        React.createElement("div", { className: "flex flex-col justify-center items-start gap-2 text-white" },
                            props.logoUrl ?
                                React.createElement(Link, { to: props.logoUrl, className: "text-3xl font-semibold" }, name)
                                :
                                    React.createElement("p", { className: "text-3xl font-semibold" }, name),
                            React.createElement("p", { className: "text-xl font-light" }, description)),
                        React.createElement("div", { className: "flex flex-col justify-center items-start gap-2 text-white" },
                            React.createElement("p", { className: "text-2xl font-semibold" }, "Head Office"),
                            React.createElement("p", { className: "" },
                                "No. 6 Tuas Avenue 6, Singapore 639311 ",
                                React.createElement("br", null),
                                "(Tel) +65 6558 6259"))),
                    React.createElement("div", { className: "w-full lg:w-auto grid grid-cols-2 sm:grid-cols-3 md:grid-cols-3 gap-6 md:gap-16" }, menuItems.map(function (menuItem, i) {
                        return (React.createElement("div", { key: "footer-menu-".concat(i) },
                            React.createElement("p", { className: "mb-4 text-xl text-white font-semibold" }, menuItem.heading),
                            React.createElement("ul", { className: "flex flex-col justify-center items-start gap-4 text-white" }, menuItem.items.map(function (listItem, j) {
                                return (React.createElement("li", { key: "footer-item-".concat(j) },
                                    React.createElement(Link, { to: listItem.to, target: listItem.target, hideCrawl: listItem.hideCrawl, className: "block no-underline" }, listItem.content)));
                            }))));
                    }))),
                React.createElement("hr", { className: "h-1 w-full my-4 border-white" }),
                React.createElement("div", { className: "grid grid-cols-1 md:grid-cols-2 w-full" },
                    React.createElement("div", { className: "flex justify-center md:justify-start items-center text-white my-2" },
                        "Copyright \u00A9 2017 - ",
                        currentTs.getFullYear(),
                        " | Winspec Group"),
                    React.createElement("div", { className: "flex justify-center md:justify-end items-center gap-4 md:gap-6 my-2" }, mediaItems.map(function (mediaItem, i) {
                        return (React.createElement(Link, { key: "footer-social-item-".concat(i), to: mediaItem.to, target: mediaItem.target || "_blank", hideCrawl: mediaItem.hideCrawl }, mediaItem.content));
                    })))))));
}

var DefaultContext = {
  color: undefined,
  size: undefined,
  className: undefined,
  style: undefined,
  attr: undefined
};
var IconContext = React__default.createContext && /*#__PURE__*/React__default.createContext(DefaultContext);

var _excluded = ["attr", "size", "title"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function Tree2Element(tree) {
  return tree && tree.map((node, i) => /*#__PURE__*/React__default.createElement(node.tag, _objectSpread({
    key: i
  }, node.attr), Tree2Element(node.child)));
}
function GenIcon(data) {
  // eslint-disable-next-line react/display-name
  return props => /*#__PURE__*/React__default.createElement(IconBase, _extends({
    attr: _objectSpread({}, data.attr)
  }, props), Tree2Element(data.child));
}
function IconBase(props) {
  var elem = conf => {
    var {
        attr,
        size,
        title
      } = props,
      svgProps = _objectWithoutProperties(props, _excluded);
    var computedSize = size || conf.size || "1em";
    var className;
    if (conf.className) className = conf.className;
    if (props.className) className = (className ? className + " " : "") + props.className;
    return /*#__PURE__*/React__default.createElement("svg", _extends({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, conf.attr, attr, svgProps, {
      className: className,
      style: _objectSpread(_objectSpread({
        color: props.color || conf.color
      }, conf.style), props.style),
      height: computedSize,
      width: computedSize,
      xmlns: "http://www.w3.org/2000/svg"
    }), title && /*#__PURE__*/React__default.createElement("title", null, title), props.children);
  };
  return IconContext !== undefined ? /*#__PURE__*/React__default.createElement(IconContext.Consumer, null, conf => elem(conf)) : elem(DefaultContext);
}

// THIS FILE IS AUTO GENERATED
function FaClock (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256,8C119,8,8,119,8,256S119,504,256,504,504,393,504,256,393,8,256,8Zm92.49,313h0l-20,25a16,16,0,0,1-22.49,2.5h0l-67-49.72a40,40,0,0,1-15-31.23V112a16,16,0,0,1,16-16h32a16,16,0,0,1,16,16V256l58,42.5A16,16,0,0,1,348.49,321Z"},"child":[]}]})(props);
}function FaEnvelope$1 (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M502.3 190.8c3.9-3.1 9.7-.2 9.7 4.7V400c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V195.6c0-5 5.7-7.8 9.7-4.7 22.4 17.4 52.1 39.5 154.1 113.6 21.1 15.4 56.7 47.8 92.2 47.6 35.7.3 72-32.8 92.3-47.6 102-74.1 131.6-96.3 154-113.7zM256 320c23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7 5.8-4.5 9.2-11.5 9.2-18.9v-19c0-26.5-21.5-48-48-48H48C21.5 64 0 85.5 0 112v19c0 7.4 3.4 14.3 9.2 18.9 30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4z"},"child":[]}]})(props);
}function FaPhone (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M493.4 24.6l-104-24c-11.3-2.6-22.9 3.3-27.5 13.9l-48 112c-4.2 9.8-1.4 21.3 6.9 28l60.6 49.6c-36 76.7-98.9 140.5-177.2 177.2l-49.6-60.6c-6.8-8.3-18.2-11.1-28-6.9l-112 48C3.9 366.5-2 378.1.6 389.4l24 104C27.1 504.2 36.7 512 48 512c256.1 0 464-207.5 464-464 0-11.2-7.7-20.9-18.6-23.4z"},"child":[]}]})(props);
}

function Aglogis(props) {
    var _a = props.menuItems, menuItems = _a === void 0 ? [] : _a, _b = props.mediaItems, mediaItems = _b === void 0 ? [] : _b;
    var currentTs = new Date();
    return (React.createElement(Base, null,
        React.createElement("div", { className: "bg-aglogis-primary px-4 sm:px-20 md:px-6 lg:px-24 3xl:px-64 py-4 md:py-7" },
            React.createElement(Container, { size: "md" },
                React.createElement("div", { className: "flex flex-wrap justify-center text-white" },
                    React.createElement("div", { className: "flex flex-col md:!flex-row justify-between items-center md:!items-start gap-6 w-full py-4 font-open-sans" },
                        menuItems.map(function (menu, i) {
                            return (React.createElement("div", { className: "w-full", key: "footer-menu-".concat(i) },
                                React.createElement("p", { className: "mb-6 text-xl md:!text-3xl text-center md:!text-left font-bold" }, menu.heading),
                                menu.items.length > 0 &&
                                    React.createElement("ul", { className: "flex flex-col justify-center items-center md:!items-start gap-2 text-lg" }, menu.items.map(function (item, j) {
                                        return (React.createElement("li", { key: "footer-item-".concat(i, "-").concat(j) },
                                            React.createElement(Link, { to: item.to, target: item.target, hideCrawl: item.hideCrawl, className: "block no-underline" }, item.content)));
                                    })),
                                i === 0 && mediaItems.length > 0 &&
                                    React.createElement("ul", { className: "my-4 flex flex-row justify-center md:!justify-start gap-2" }, mediaItems.map(function (media, m) {
                                        return (React.createElement("li", { key: "media-item-".concat(i, "-").concat(m) },
                                            React.createElement(Link, { to: media.to, target: media.target, hideCrawl: media.hideCrawl, className: "block no-underline" }, media.content)));
                                    }))));
                        }),
                        React.createElement("div", { className: "w-full text-center md:!text-left" },
                            React.createElement("p", { className: "mb-6 text-xl md:!text-3xl font-bold" }, "Container Services"),
                            React.createElement("p", { className: "text-lg mb-2" }, "For container inquiries or assistance, reach out to us at:"),
                            React.createElement("ul", { className: "flex flex-col justify-center items-center md:!items-start gap-2 text-lg" },
                                React.createElement("li", { className: "flex flex-row justify-center items-center gap-4" },
                                    React.createElement(FaPhone, { className: "w-5 h-5", "aria-hidden": "true" }),
                                    "+65 9780 3528"),
                                React.createElement("li", { className: "flex flex-row justify-center items-center gap-4" },
                                    React.createElement(FaEnvelope$1, { className: "w-5 h-5", "aria-hidden": "true" }),
                                    "winston@aglogis.com"),
                                React.createElement("li", { className: "flex flex-row justify-center items-center gap-4" },
                                    React.createElement(FaClock, { className: "w-5 h-5", "aria-hidden": "true" }),
                                    "Mon-Fri: 8:30am - 5:30PM"))),
                        React.createElement("div", { className: "w-full text-center md:!text-left" },
                            React.createElement("p", { className: "mb-6 text-xl md:!text-3xl font-bold" }, "Need Help?"),
                            React.createElement("p", { className: "text-lg mb-2" }, "We're here to help with your enquiry!"),
                            React.createElement("ul", { className: "flex flex-col justify-center items-center md:!items-start gap-2 text-lg" },
                                React.createElement("li", { className: "flex flex-row justify-center items-center gap-4" },
                                    React.createElement(FaPhone, { className: "w-5 h-5", "aria-hidden": "true" }),
                                    "+65 6558 6042"),
                                React.createElement("li", { className: "flex flex-row justify-center items-center gap-4" },
                                    React.createElement(FaEnvelope$1, { className: "w-5 h-5", "aria-hidden": "true" }),
                                    "enquiry@aglogis.com"),
                                React.createElement("li", { className: "flex flex-row justify-center items-center gap-4" },
                                    React.createElement(FaClock, { className: "w-5 h-5", "aria-hidden": "true" }),
                                    "Mon-Fri: 8:30am - 5:30PM")))),
                    React.createElement("hr", { className: "h-1 w-full my-4 border-white" }),
                    React.createElement("div", { className: "grid grid-cols-1 w-full font-roboto-mono font-light" },
                        React.createElement("p", { className: "flex justify-center items-center my-2 text-lg text-white" },
                            "Copyright \u00A9 ",
                            currentTs.getFullYear(),
                            " | AG Logis")))))));
}

function AlliedDepot(props) {
    var _a = props.description, description = _a === void 0 ? "Innovative and modern logistic solution." : _a, backgroundImage = props.backgroundImage, copyrightLabel = props.copyrightLabel, _b = props.mediaItems, mediaItems = _b === void 0 ? [] : _b;
    return (React.createElement(Base, null,
        React.createElement("div", { className: "w-full bg-cover bg-center p-2", style: { backgroundImage: "url(".concat(backgroundImage, ")") } },
            React.createElement(Container, { size: "full" },
                React.createElement("div", { className: "grid grid-cols-12 content-center items-center gap-4 p-4" },
                    React.createElement("div", { className: "col-span-12 sm:!col-span-4 lg:!col-span-3 xl:!col-span-2 sm:order-last" }, props.rightChildren),
                    React.createElement("div", { className: "col-span-12 sm:!col-span-8 lg:!col-span-9 xl:!col-span-10" },
                        React.createElement("div", { className: "flex flex-col gap-3" },
                            React.createElement("img", { src: props.logoImage, alt: props.logoAlt, className: "max-w-52 h-auto" }),
                            description &&
                                React.createElement("p", { className: "text-sm text-zinc-400" }, description),
                            mediaItems.length > 0 &&
                                React.createElement("div", { className: "flex flex-row gap-2" }, mediaItems.map(function (item, i) {
                                    return (React.createElement(Link, { key: "media-item-".concat(i), to: item.to, target: item.target, hideCrawl: item.hideCrawl, "aria-label": item.label }, item.content));
                                })),
                            copyrightLabel &&
                                React.createElement("p", { className: "text-sm text-white" }, copyrightLabel))))))));
}

var ButtonType;
(function (ButtonType) {
    ButtonType["SUBMIT"] = "submit";
    ButtonType["RESET"] = "reset";
    ButtonType["BUTTON"] = "button";
})(ButtonType || (ButtonType = {}));
var ButtonVariant;
(function (ButtonVariant) {
    ButtonVariant["PRIMARY"] = "primary";
    ButtonVariant["SECONDARY"] = "secondary";
    ButtonVariant["INFO"] = "info";
    ButtonVariant["SUCCESS"] = "success";
    ButtonVariant["DANGER"] = "danger";
    ButtonVariant["WARNING"] = "warning";
})(ButtonVariant || (ButtonVariant = {}));
var ButtonSize;
(function (ButtonSize) {
    ButtonSize["XXLARGE"] = "2xl";
    ButtonSize["XLARGE"] = "xl";
    ButtonSize["LARGE"] = "lg";
    ButtonSize["MEDIUM"] = "md";
    ButtonSize["SMALL"] = "sm";
})(ButtonSize || (ButtonSize = {}));
var ButtonTheme;
(function (ButtonTheme) {
    ButtonTheme["ALLIEDCONTAINER"] = "acem";
    ButtonTheme["ALLIEDCONTAINER2"] = "acem2";
    ButtonTheme["ALLIEDFOOD"] = "afood";
    ButtonTheme["ALLIEDDEPOT"] = "acds";
    ButtonTheme["WINSPEC"] = "winspec";
    ButtonTheme["AGLOGIS"] = "aglogis";
    ButtonTheme["ACSMARINE"] = "acsm";
})(ButtonTheme || (ButtonTheme = {}));
var themes = new Map();
var acemTheme = new Map();
acemTheme.set("", "inline-block rounded-full ease-out duration-500 disabled:bg-gray-300 disabled:border-0 disabled:text-gray-800 font-bold");
acemTheme.set("variant-".concat(ButtonVariant.PRIMARY), "bg-acem-red text-acem-white");
acemTheme.set("variant-".concat(ButtonVariant.SECONDARY), "bg-white text-acem-black border-1 border-acem-black");
acemTheme.set("variant-".concat(ButtonVariant.INFO), "bg-blue-500 hover:bg-blue-400 text-white");
acemTheme.set("variant-".concat(ButtonVariant.SUCCESS), "bg-green-600 hover:bg-green-500 text-white");
acemTheme.set("variant-".concat(ButtonVariant.DANGER), "bg-red-600 hover:bg-red-400 text-white");
acemTheme.set("variant-".concat(ButtonVariant.WARNING), "bg-amber-600 hover:bg-amber-700 text-white");
acemTheme.set("size-".concat(ButtonSize.XXLARGE), "xs:py-4 sm:py-4 md:py-4 lg:py-6 xs:px-3 sm:px-6 md:px-7 lg:px-8 text-base md:text-xl");
acemTheme.set("size-".concat(ButtonSize.XLARGE), "xs:py-3.5 sm:py-3.5 md:py-3.5 lg:py-4 xs:px-3 sm:px-4 md:px-5 lg:px-6 text-base md:text-lg");
acemTheme.set("size-".concat(ButtonSize.LARGE), "py-2.5 px-4");
acemTheme.set("size-".concat(ButtonSize.MEDIUM), "py-2 px-3");
acemTheme.set("size-".concat(ButtonSize.SMALL), "py-1 px-2 text-sm");
acemTheme.set("disabled-true", "cursor-not-allowed");
acemTheme.set("disabled-false", "cursor-pointer");
var acem2Theme = new Map();
acem2Theme.set("", "inline-block rounded-md ease-out duration-500 disabled:bg-gray-300 disabled:border-0 disabled:text-gray-800 font-satoshi font-medium");
acem2Theme.set("variant-".concat(ButtonVariant.PRIMARY), "bg-acem2-primary hover:bg-acem2-maroon text-white");
acem2Theme.set("variant-".concat(ButtonVariant.SECONDARY), "bg-acem2-white hover:bg-acem2-cloud text-acem2-black border-1 border-acem2-black");
acem2Theme.set("variant-".concat(ButtonVariant.INFO), "bg-blue-500 hover:bg-blue-400 text-white");
acem2Theme.set("variant-".concat(ButtonVariant.SUCCESS), "bg-green-600 hover:bg-green-500 text-white");
acem2Theme.set("variant-".concat(ButtonVariant.DANGER), "bg-red-600 hover:bg-red-400 text-white");
acem2Theme.set("variant-".concat(ButtonVariant.WARNING), "bg-amber-600 hover:bg-amber-700 text-white");
acem2Theme.set("size-".concat(ButtonSize.XXLARGE), "xs:py-4 sm:py-4 md:py-4 lg:py-6 xs:px-3 sm:px-6 md:px-7 lg:px-8 text-base md:text-xl");
acem2Theme.set("size-".concat(ButtonSize.XLARGE), "xs:py-3.5 sm:py-3.5 md:py-3.5 lg:py-4 xs:px-3 sm:px-4 md:px-5 lg:px-6 text-base md:text-lg");
acem2Theme.set("size-".concat(ButtonSize.LARGE), "py-2.5 px-4");
acem2Theme.set("size-".concat(ButtonSize.MEDIUM), "py-2 px-3");
acem2Theme.set("size-".concat(ButtonSize.SMALL), "py-1 px-2 text-sm");
acem2Theme.set("disabled-true", "cursor-not-allowed");
acem2Theme.set("disabled-false", "cursor-pointer");
var afoodTheme = new Map();
afoodTheme.set("", "inline-block rounded-md ease-out duration-500 disabled:bg-gray-300 disabled:border-0 disabled:text-gray-800 font-poppins");
afoodTheme.set("variant-".concat(ButtonVariant.PRIMARY), "bg-afood-primary border-1 border-transparent hover:bg-white hover:border-afood-primary text-black");
afoodTheme.set("variant-".concat(ButtonVariant.SECONDARY), "bg-afood-secondary border-1 border-transparent hover:bg-white hover:border-afood-secondary text-black");
afoodTheme.set("variant-".concat(ButtonVariant.INFO), "bg-blue-500 hover:bg-blue-400 text-white");
afoodTheme.set("variant-".concat(ButtonVariant.SUCCESS), "bg-green-600 hover:bg-green-500 text-white");
afoodTheme.set("variant-".concat(ButtonVariant.DANGER), "bg-red-600 hover:bg-red-400 text-white");
afoodTheme.set("variant-".concat(ButtonVariant.WARNING), "bg-amber-600 hover:bg-amber-700 text-white");
afoodTheme.set("size-".concat(ButtonSize.XXLARGE), "xs:py-4 sm:py-4 md:py-4 lg:py-6 xs:px-3 sm:px-6 md:px-7 lg:px-8 text-base md:text-xl");
afoodTheme.set("size-".concat(ButtonSize.XLARGE), "xs:py-3.5 sm:py-3.5 md:py-3.5 lg:py-4 xs:px-3 sm:px-4 md:px-5 lg:px-6 text-base md:text-lg");
afoodTheme.set("size-".concat(ButtonSize.LARGE), "py-2.5 px-4");
afoodTheme.set("size-".concat(ButtonSize.MEDIUM), "py-2 px-3");
afoodTheme.set("size-".concat(ButtonSize.SMALL), "py-1 px-2 text-sm");
afoodTheme.set("disabled-true", "cursor-not-allowed");
afoodTheme.set("disabled-false", "cursor-pointer");
var winspecTheme = new Map();
winspecTheme.set("", "inline-block rounded-full ease-out duration-500 disabled:bg-gray-300 disabled:border-0 disabled:text-gray-800 font-bold");
winspecTheme.set("variant-".concat(ButtonVariant.PRIMARY), "bg-winspec-primary border-1 border-transparent hover:bg-white text-white hover:text-winspec-primary hover:border-winspec-primary");
winspecTheme.set("variant-".concat(ButtonVariant.SECONDARY), "bg-white border-1 border-black text-black");
winspecTheme.set("variant-".concat(ButtonVariant.INFO), "bg-blue-500 hover:bg-blue-400 text-white");
winspecTheme.set("variant-".concat(ButtonVariant.SUCCESS), "bg-green-600 hover:bg-green-500 text-white");
winspecTheme.set("variant-".concat(ButtonVariant.DANGER), "bg-red-600 hover:bg-red-400 text-white");
winspecTheme.set("variant-".concat(ButtonVariant.WARNING), "bg-amber-600 hover:bg-amber-700 text-white");
winspecTheme.set("size-".concat(ButtonSize.XXLARGE), "xs:py-4 sm:py-4 md:py-4 lg:py-6 xs:px-3 sm:px-6 md:px-7 lg:px-8 text-base md:text-xl");
winspecTheme.set("size-".concat(ButtonSize.XLARGE), "xs:py-3.5 sm:py-3.5 md:py-3.5 lg:py-4 xs:px-3 sm:px-4 md:px-5 lg:px-6 text-base md:text-lg");
winspecTheme.set("size-".concat(ButtonSize.LARGE), "py-2 px-6");
winspecTheme.set("size-".concat(ButtonSize.MEDIUM), "py-2 px-3");
winspecTheme.set("size-".concat(ButtonSize.SMALL), "py-1 px-2 text-sm");
winspecTheme.set("disabled-true", "cursor-not-allowed");
winspecTheme.set("disabled-false", "cursor-pointer");
var aglogisTheme = new Map();
aglogisTheme.set("", "inline-block rounded-2xl ease-out duration-500 disabled:bg-gray-300 disabled:border-0 disabled:text-gray-800 font-open-sans");
aglogisTheme.set("variant-".concat(ButtonVariant.PRIMARY), "bg-aglogis-primary text-white");
aglogisTheme.set("variant-".concat(ButtonVariant.SECONDARY), "bg-white text-black border-1 border-aglogis-primary");
aglogisTheme.set("variant-".concat(ButtonVariant.INFO), "bg-blue-500 hover:bg-blue-400 text-white");
aglogisTheme.set("variant-".concat(ButtonVariant.SUCCESS), "bg-green-600 hover:bg-green-500 text-white");
aglogisTheme.set("variant-".concat(ButtonVariant.DANGER), "bg-red-600 hover:bg-red-400 text-white");
aglogisTheme.set("variant-".concat(ButtonVariant.WARNING), "bg-amber-600 hover:bg-amber-700 text-white");
aglogisTheme.set("size-".concat(ButtonSize.XXLARGE), "xs:py-4 sm:py-4 md:py-4 lg:py-6 xs:px-3 sm:px-6 md:px-7 lg:px-8 text-base md:text-xl");
aglogisTheme.set("size-".concat(ButtonSize.XLARGE), "xs:py-3.5 sm:py-3.5 md:py-3.5 lg:py-4 xs:px-3 sm:px-4 md:px-5 lg:px-6 text-base md:text-lg");
aglogisTheme.set("size-".concat(ButtonSize.LARGE), "py-2.5 px-4");
aglogisTheme.set("size-".concat(ButtonSize.MEDIUM), "py-2 px-3");
aglogisTheme.set("size-".concat(ButtonSize.SMALL), "py-1 px-2 text-sm");
aglogisTheme.set("disabled-true", "cursor-not-allowed");
aglogisTheme.set("disabled-false", "cursor-pointer");
var acdsTheme = new Map();
acdsTheme.set("", "inline-block rounded-full ease-out duration-500 disabled:bg-gray-300 disabled:border-0 disabled:text-gray-800 font-bold");
acdsTheme.set("variant-".concat(ButtonVariant.PRIMARY), "bg-acds-primary text-white hover:bg-white hover:text-acds-primary border-1 border-transparent hover:border-acds-primary");
acdsTheme.set("variant-".concat(ButtonVariant.SECONDARY), "bg-white text-black border-1 border-black hover:bg-acds-primary hover:text-white hover:border-acds-primary");
acdsTheme.set("variant-".concat(ButtonVariant.INFO), "bg-blue-500 hover:bg-blue-400 text-white");
acdsTheme.set("variant-".concat(ButtonVariant.SUCCESS), "bg-green-600 hover:bg-green-500 text-white");
acdsTheme.set("variant-".concat(ButtonVariant.DANGER), "bg-red-600 hover:bg-red-400 text-white");
acdsTheme.set("variant-".concat(ButtonVariant.WARNING), "bg-amber-600 hover:bg-amber-700 text-white");
acdsTheme.set("size-".concat(ButtonSize.XXLARGE), "xs:py-4 sm:py-4 md:py-4 lg:py-6 xs:px-3 sm:px-6 md:px-7 lg:px-8 text-base md:text-xl");
acdsTheme.set("size-".concat(ButtonSize.XLARGE), "xs:py-3.5 sm:py-3.5 md:py-3.5 lg:py-4 xs:px-3 sm:px-4 md:px-5 lg:px-6 text-base md:text-lg");
acdsTheme.set("size-".concat(ButtonSize.LARGE), "py-2.5 px-4");
acdsTheme.set("size-".concat(ButtonSize.MEDIUM), "py-2 px-3");
acdsTheme.set("size-".concat(ButtonSize.SMALL), "py-1 px-2 text-sm");
acdsTheme.set("disabled-true", "cursor-not-allowed");
acdsTheme.set("disabled-false", "cursor-pointer");
var acsmTheme = new Map();
acsmTheme.set("", "inline-block rounded-full ease-out duration-500 disabled:bg-gray-300 disabled:border-0 disabled:text-gray-800 font-verdana sm:!font-poppins");
acsmTheme.set("variant-".concat(ButtonVariant.PRIMARY), "bg-acsm-primary text-black border-1 border-transparent hover:border-black");
acsmTheme.set("variant-".concat(ButtonVariant.SECONDARY), "bg-white text-black border-1 border-transparent hover:border-black");
acsmTheme.set("variant-".concat(ButtonVariant.INFO), "bg-blue-500 hover:bg-blue-400 text-white");
acsmTheme.set("variant-".concat(ButtonVariant.SUCCESS), "bg-green-600 hover:bg-green-500 text-white");
acsmTheme.set("variant-".concat(ButtonVariant.DANGER), "bg-red-600 hover:bg-red-400 text-white");
acsmTheme.set("variant-".concat(ButtonVariant.WARNING), "bg-amber-600 hover:bg-amber-700 text-white");
acsmTheme.set("size-".concat(ButtonSize.XXLARGE), "xs:py-4 sm:py-4 md:py-4 lg:py-6 xs:px-4 sm:px-6 md:px-8 lg:px-10 text-base md:text-xl");
acsmTheme.set("size-".concat(ButtonSize.XLARGE), "xs:py-3.5 sm:py-3.5 md:py-3.5 lg:py-4 xs:px-4 sm:px-5 md:px-6 lg:px-9 text-base md:text-lg");
acsmTheme.set("size-".concat(ButtonSize.LARGE), "py-3 px-8");
acsmTheme.set("size-".concat(ButtonSize.MEDIUM), "py-2 px-7");
acsmTheme.set("size-".concat(ButtonSize.SMALL), "py-1 px-3 text-sm");
acsmTheme.set("disabled-true", "cursor-not-allowed");
acsmTheme.set("disabled-false", "cursor-pointer");
themes.set(ButtonTheme.ALLIEDCONTAINER, acemTheme);
themes.set(ButtonTheme.ALLIEDCONTAINER2, acem2Theme);
themes.set(ButtonTheme.ALLIEDFOOD, afoodTheme);
themes.set(ButtonTheme.ALLIEDDEPOT, acdsTheme);
themes.set(ButtonTheme.WINSPEC, winspecTheme);
themes.set(ButtonTheme.AGLOGIS, aglogisTheme);
themes.set(ButtonTheme.ACSMARINE, acsmTheme);
var ButtonStyle = /** @class */ (function () {
    function ButtonStyle() {
        this.theme = "";
        this.variant = "";
        this.size = "";
        this.disabled = false;
        this.appendedClassNames = "";
    }
    ButtonStyle.prototype.build = function () {
        var style = "";
        var theme = themes.get(this.theme);
        if (!theme) {
            return style;
        }
        if (theme.has("")) {
            style += theme.get("");
        }
        if (theme.has("variant-".concat(this.variant))) {
            style += " " + theme.get("variant-".concat(this.variant));
        }
        if (theme.has("size-".concat(this.size))) {
            style += " " + theme.get("size-".concat(this.size));
        }
        if (theme.has("disabled-".concat(this.disabled))) {
            style += " " + theme.get("disabled-".concat(this.disabled));
        }
        if (this.appendedClassNames !== "") {
            style += " " + this.appendedClassNames;
        }
        return style;
    };
    ButtonStyle.prototype.setTheme = function (theme) {
        this.theme = theme;
        return this;
    };
    ButtonStyle.prototype.setVariant = function (variant) {
        this.variant = variant;
        return this;
    };
    ButtonStyle.prototype.setSize = function (size) {
        this.size = size;
        return this;
    };
    ButtonStyle.prototype.setDisabled = function (disabled) {
        this.disabled = disabled || false;
        return this;
    };
    ButtonStyle.prototype.appendClassNames = function (classNames) {
        this.appendedClassNames = classNames || "";
        return this;
    };
    return ButtonStyle;
}());

var styleBuilder = new ButtonStyle();
var ButtonLink = React.forwardRef(function (props, ref) {
    var themeCtx = React.useContext(ThemeContext);
    var _a = props.theme, theme = _a === void 0 ? themeCtx.theme || ButtonTheme.ALLIEDCONTAINER : _a, _b = props.variant, variant = _b === void 0 ? ButtonVariant.PRIMARY : _b, _c = props.size, size = _c === void 0 ? ButtonSize.MEDIUM : _c;
    var handleClick = function () {
        props.onClick && props.onClick();
    };
    var styleClassNames = styleBuilder.
        setTheme(theme).
        setVariant(variant).
        setSize(size).
        appendClassNames(props.appendClassNames).
        build();
    return (React.createElement(Link, { ref: ref, to: props.to, target: props.target, hideCrawl: props.hideCrawl, className: styleClassNames, style: __assign({ textDecoration: "none" }, props.style), onClick: handleClick }, props.children));
});

// THIS FILE IS AUTO GENERATED
function FaEnvelope (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0L492.8 150.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48H48zM0 176V384c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V176L294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176z"},"child":[]}]})(props);
}

function AlliedMarine(props) {
    var _a = props.menuItems, menuItems = _a === void 0 ? [] : _a;
    return (React.createElement(Base, { appendClassNames: "font-verdana sm:!font-poppins py-6 md:py-16 bg-white border-t-1 border-t-acsm-secondary" },
        React.createElement(Container, { size: "md" },
            React.createElement("div", { className: "grid grid-cols-12 gap-2 xl:gap-4 divide-x-0 lg:divide-x-2 divide-y-2 lg:divide-y-0 divide-black" },
                React.createElement("div", { className: "col-span-12 lg:col-span-5" },
                    React.createElement("div", { className: "flex flex-col gap-4 w-fit py-4" },
                        React.createElement("div", { className: "flex flex-row justify-start gap-2 xl:gap-6 divide-x-2 divide-black" },
                            props.logoUrl ?
                                React.createElement(Link, { to: props.logoUrl, className: "flex flex-row items-center gap-2 px-2 no-underline text-sm" },
                                    React.createElement("img", { src: props.logoImage, alt: "logo", className: "w-7 h-12" }),
                                    props.logoDescription &&
                                        React.createElement("span", { className: "font-verdana text-xs text-[#231F20] hidden xl:block" }, props.logoDescription))
                                :
                                    React.createElement("div", { className: "flex flex-row items-center gap-2 px-2" },
                                        React.createElement("img", { src: props.logoImage, alt: "logo", className: "w-7 h-12" }),
                                        props.logoDescription &&
                                            React.createElement("span", { className: "font-verdana text-xs text-[#231F20] hidden xl:block" }, props.logoDescription)),
                            props.sublogoUrl ?
                                React.createElement(Link, { to: props.sublogoUrl, className: "flex flex-row items-end gap-2 pl-4 pr-2 no-underline text-sm" },
                                    React.createElement("img", { src: props.sublogoImage, alt: "sublogo", className: "w-10 h-12" }),
                                    props.sublogoDescription &&
                                        React.createElement("span", { className: "text-xs hidden xl:block" }, props.sublogoDescription))
                                :
                                    React.createElement("div", { className: "flex flex-row items-end gap-2 pl-4 pr-2" },
                                        React.createElement("img", { src: props.sublogoImage, alt: "sublogo", className: "w-10 h-12" }),
                                        props.sublogoDescription &&
                                            React.createElement("span", { className: "text-xs hidden xl:block" }, props.sublogoDescription))),
                        React.createElement("div", { className: "w-full" },
                            React.createElement(ButtonLink, { to: "mailto:sales@acsmarine.sg", theme: "acsm", variant: "primary", size: "md", appendClassNames: "flex flex-row justify-start items-center gap-2 text-xs md:!text-base" },
                                React.createElement(FaEnvelope, { className: "block h-4 w-4", "aria-hidden": "true" }),
                                React.createElement("span", null, "sales@acsmarine.sg"))))),
                React.createElement("div", { className: "col-span-12 lg:col-span-7 lg:pl-4 xl:pl-6 2xl:pl-16" },
                    React.createElement("div", { className: "grid grid-cols-1 lg:grid-cols-2 gap-8 py-4" }, menuItems.map(function (menuItem, i) {
                        return (React.createElement("div", { key: "footer-menu-".concat(i) },
                            menuItem.to ?
                                React.createElement(Link, { to: menuItem.to, target: menuItem.target, hideCrawl: menuItem.hideCrawl, className: "block no-underline text-xl text-acsm-red font-bold mb-4" }, menuItem.content)
                                :
                                    React.createElement("p", { className: "block text-xl text-acsm-red font-bold mb-4" }, menuItem.content),
                            React.createElement("ul", { className: "grid grid-rows-5 grid-flow-col gap-2" }, menuItem.items.map(function (listItem, j) {
                                return (React.createElement("li", { key: "footer-item-".concat(j) },
                                    React.createElement(Link, { to: listItem.to, target: listItem.target, hideCrawl: listItem.hideCrawl, className: "block no-underline text-black hover:text-acsm-primary" }, listItem.content)));
                            }))));
                    })))))));
}

var Footer = function (props) {
    return React.createElement(Base, __assign({}, props));
};
Footer.AlliedContainer = AlliedContainer;
Footer.AlliedContainer2 = AlliedContainer2;
Footer.AlliedFood = AlliedFood;
Footer.Winspec = Winspec;
Footer.Aglogis = Aglogis;
Footer.AlliedDepot = AlliedDepot;
Footer.AlliedMarine = AlliedMarine;

export { Footer };
